// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"295":"569e27d3","348":"866725d3","594":"21b37128","641":"942ad2fa","825":"b978d774"}[chunkId] + ".js";
};